export const TASK_TITLE_MAX_LENGTH = 50;
export const DEFAULT_PERSON_NAME = {
    first: "Unknown",
    middle: "",
    last: "Person",
};
// link to documentation for task creation process
export const TASK_CREATION_PROCESS_DOC = "https://docs.google.com/document/d/15lMZ76q6D8_qkR1-Y4d6BDzi6k29SKn0Mr1q7C95KXU/edit?tab=t.0";
//# sourceMappingURL=common.js.map